import { Box } from '@material-ui/core';
import { ReactElement, useMemo } from 'react';
import {
	getCasperVideo,
	getCloudinaryContent,
	getSchoolTvIdMatchArray,
	getVimeoIdMatchArray,
	getYouTubeIdMatchArray,
	isCasperAsset
} from '../../../utils';

import './video-player.styles.scss';

export interface IVideoPlayerProps {
	videoUrl: string;
}

export function VideoPlayer(props: IVideoPlayerProps): ReactElement {
	const { videoUrl } = props;

	const allowedContentTypes: string[] = ['.mp4'];

	const isAsset: boolean = useMemo<boolean>(() => {
		return isCasperAsset(videoUrl);
	}, [videoUrl]);

	const isUploadedContent: boolean = useMemo<boolean>(() => {
		const isBlob: boolean = videoUrl.includes('blob:');
		const isAllowedContentType: boolean = allowedContentTypes.some(
			(type: string) => videoUrl.includes(type)
		);
		return isBlob || isAllowedContentType;
	}, [videoUrl]);

	const url: string | undefined = useMemo<string | undefined>(() => {
		const youtubeUrl: string | undefined = getYouTubeUrl(videoUrl);
		if (youtubeUrl) return youtubeUrl;
		const vimeoUrl: string | undefined = getVimeoUrl(videoUrl);
		if (vimeoUrl) return vimeoUrl;
		const schoolTvUrl: string | undefined = getSchoolTvUrl(videoUrl);
		if (schoolTvUrl) return schoolTvUrl;
		return undefined;
	}, [videoUrl]);

	function getVimeoUrl(url: string): string | undefined {
		const match: RegExpMatchArray | null = getVimeoIdMatchArray(url);
		if (match === null) return undefined;
		return `https://player.vimeo.com/video/${match[1]}`;
	}

	function getYouTubeUrl(url: string): string | undefined {
		const match: RegExpMatchArray | null = getYouTubeIdMatchArray(url);
		if (match === null) return undefined;

		const youtubeId: string | undefined =
			match[7].length === 11 ? match[7] : undefined;
		if (youtubeId === undefined) return undefined;

		return `https://youtube.com/embed/${youtubeId}`;
	}

	function getSchoolTvUrl(url: string) {
		const match: RegExpMatchArray | null = getSchoolTvIdMatchArray(url);
		if (match === null) return undefined;
		return `https://player.ntr.nl/index.php?id=${match[1]}`;
	}

	return (
		<Box className="video-player">
			{isAsset && (
				<video controls className="casper-video">
					<source src={getCasperVideo(videoUrl)} type="video/mp4" />
				</video>
			)}
			{isUploadedContent && (
				<video controls className="casper-video">
					<source
						src={getCloudinaryContent(videoUrl, 'video')}
						type="video/mp4"
					/>
				</video>
			)}
			{url && (
				<iframe
					title={url}
					src={url}
					allow="fullscreen; picture-in-picture; encrypted-media; geolocation"
					allowFullScreen
				/>
			)}
		</Box>
	);
}
